import { render, staticRenderFns } from "./expense-card.vue?vue&type=template&id=4724cf57&"
import script from "./expense-card.vue?vue&type=script&lang=js&"
export * from "./expense-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports